<template>
  <SelectWithSearch
    label="Pesquisar Cliente"
    placeholder="Pesquise o Nome/CPF/CNPJ"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="clientCollection"
    :search="search"
    :error="error"
    :filterBy="personFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected" style="text-transform: uppercase">
        {{ props.data.name }}
        <br />
        CPF/CNPJ: {{ props.data.identificationFormatted }}
      </div>
    </template>
    <template slot="no-options"> Nenhum cliente encontrado </template>
    <template slot="selected" slot-scope="props">
      <div class="selected" style="text-transform: uppercase">
        {{ props.data.name }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapGetters, mapState } from 'vuex';
import SearchMixin from '@/core/mixins/SearchMixin';

export default {
  name: 'SelectClient',
  mixins: [SearchMixin],
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    value: {},
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setClientCollection();
  },
  computed: {
    ...mapState('person', ['clientCollection']),
    ...mapGetters('nfse', [
      'getDefaultAddressState',
      'getDefaultPhoneState',
      'getDefaultReceiverState',
    ]),
  },
  methods: {
    ...mapActions('person', ['setClientCollection']),

    async search(search) {
      await this.setClientCollection(search);
    },
    change(value) {
      if (!value) {
        this.$emit('input', this.getDefaultReceiverState);
        return;
      }

      const client = {
        ...value,
        address: value?.addressCollection[0] ?? this.getDefaultAddressState,
        phone: value?.phoneCollection[0] ?? this.getDefaultPhoneState,
      };

      this.$emit('input', client);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
